import { Checkbox } from '@consigli/facade';
import { useCallback } from 'react';

import { useFileTreeContext } from '@/pages/insight/folders/use-file-tree-context';
import { FolderDocumentsType } from '@/util/types';

import { FoldersCard } from './folders-card';

interface FoldersCardListProps {
  pageRecords: FolderDocumentsType[];
  filterItems: (items: FolderDocumentsType[]) => FolderDocumentsType[];
  handleCheckboxClick: (record: FolderDocumentsType) => void;
  onDocumentSelect: (file: FolderDocumentsType) => void;
}

export const FoldersCardList = ({
  pageRecords,
  filterItems,
  handleCheckboxClick,
  onDocumentSelect,
}: FoldersCardListProps) => {
  const { selectedCard, setSelectedCard } = useFileTreeContext();

  const handleCardClick = useCallback(
    (file: FolderDocumentsType) => {
      setSelectedCard(file.id);
      onDocumentSelect(file);
    },
    [onDocumentSelect, setSelectedCard],
  );

  return (
    <div className="px-4 h-[calc(100vh-21rem)] 2xl:h-[calc(100vh-26rem)] overflow-auto">
      {filterItems(pageRecords).map((file) => (
        <div key={file.id} className="flex items-center">
          <div className="mr-4">
            <Checkbox
              value={file.id}
              label=""
              id={file.id}
              checked={file.checked}
              onChange={() => handleCheckboxClick(file)}
            />
          </div>
          <div className="flex-1">
            <FoldersCard
              file={file}
              selected={selectedCard === file.id}
              onClick={() => handleCardClick(file)}
              handleCheckboxClick={handleCheckboxClick}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
